import { type SelectionRange } from '../../machine/state/types';
import { createEffect } from '../utils/create-effect';

export interface ClearCellsEffectDeps {
  resolveRangeToIds: (range: SelectionRange) => {
    entryIds: string[];
    fieldIds: string[];
  };
  onClearValues: (entryIds: string[], fieldIds: string[]) => void;
}

export const createClearCellsEffect = createEffect(
  ({ resolveRangeToIds, onClearValues }: ClearCellsEffectDeps) => {
    return {
      deltaTypes: ['clearCellsRequested'],

      onDelta(_delta, state) {
        const entryIdSet = new Set<string>();
        const fieldIdSet = new Set<string>();

        for (const range of state.selections) {
          const resolved = resolveRangeToIds(range);

          for (const id of resolved.entryIds) {
            entryIdSet.add(id);
          }

          for (const id of resolved.fieldIds) {
            fieldIdSet.add(id);
          }
        }

        const entryIds = [...entryIdSet];
        const fieldIds = [...fieldIdSet];

        if (entryIds.length === 0 || fieldIds.length === 0) {
          return;
        }

        onClearValues(entryIds, fieldIds);
      },
    };
  }
);
